export enum AutomationFiltersTypesMap {
  recordTypes = 'recordTypes',
  steps = 'steps',
  object = 'object',
  actionTypes = 'actionTypes',
  operations = 'operations',
  status = 'status',
  deploymentRequest = 'deploymentRequest',
}

export interface AutomationValuedFilters {
  selectedValues: string[];
}
